import React, { Component } from 'react';
import $ from '../../common/AjaxRequest';
import { Modal, Button, message, Tree } from 'antd';
import API_URL from '../../common/url';

const TreeNode = Tree.TreeNode;

class ViolationTree extends Component {
    state = {
        options : [],
        visible: false,
    };

    show = (value) => {
        this.setState({
            value,
            visible: true,
        }, () => {
            this.loadData();
        });
    };

    hide = () => {
        this.setState({
            visible: false,
        });
    };

    loadData = () => {
        const options = {
            url: `${API_URL.executeMgr.listFilterFailOption}`,
            data: {},
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    const { value = '' } = this.state;
                    const list = value.split('/');
                    let filterFailOptionId = [],
                        data = [...res.data];
                    if (list.length > 0) {
                        list.map(item => {
                            if (data.length > 0) {
                                data.map(innerItem => {
                                    if (innerItem.optionValue == item) {
                                        filterFailOptionId.push(innerItem.filterFailOptionId + '');
                                        data = innerItem.children ? [...innerItem.children] : [];
                                    }
                                });
                            }
                        });
                    }
                    this.setState({
                        filterFailOptionId,
                        dataList: res.data,
                    });
                }
            }),
        };
        $.sendRequest(options);
    }

    loopAgainstTypeId = () => {

    }

    getDataList = () => {
        const { dataList = [] } = this.state;
        let data = null;
        if (dataList.length > 0) {
            data = this.loopMap(dataList);
        }
        return data;
    }

    loopMap = data => {
        return data.map(item => {
            if (item.children && (item.children.length > 0)) {
                return (
                    <TreeNode title={item.optionValue} key={item.filterFailOptionId + ''}>
                    { this.loopMap(item.children) }
                    </TreeNode>
                )
            } else {
                return <TreeNode title={item.optionValue} key={item.filterFailOptionId + ''} />
            }
        })
    }

    onSelect = (selectedKeys, info) => {
        const { dataList } = this.state;
        const { isEnd = false } = this.props;
        const params = info.selectedNodes.length > 0 ? info.selectedNodes[0].props : null;
        if ((isEnd && params != null && params.children == undefined) || !isEnd) {
            let deep = info.node.props.pos.split('-') || [];
            let optionValue = '', data = [...dataList];
            deep.shift();
            deep.map(item => {
                if (data.length) {
                    optionValue += `/${data[item].optionValue}`;
                    data = data[item].children ? [...(data[item].children)] : [];
                } else {
                    data = [];
                }
            });
            optionValue = optionValue && optionValue.substring(1);

            this.setState({
                visible: false,
                value: optionValue,
            }, () => {
                this.props.saveFilterErrorData({filterFailOptionId: selectedKeys[0], optionValue});
            })
        } else {
            message.warning('请选择筛选失败原因已经配置的最后一级选项');
        }
    }

    render() {
        const { visible, filterFailOptionId = [] } = this.state;
        let defaultId = [...filterFailOptionId];
        defaultId.splice(0, defaultId.length - 1);
        return (
            visible &&
            <Modal
                title="选择筛选失败原因"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="600px"
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div>
                    <div className="modal-content">
                        <ul className="modal-list">
                            <li className="modal-item" style={{paddingBottom: 20}} key={Date.now()}>
                                <Tree
                                    defaultExpandedKeys={filterFailOptionId}
                                    defaultSelectedKeys={defaultId}
                                    onSelect={this.onSelect}
                                >
                                    { this.getDataList() }
                                </Tree>
                            </li>
                        </ul>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ViolationTree;


// WEBPACK FOOTER //
// ./src/components/execute/FilterErrorTree.js